import classnames from 'classnames'

export const AHeading = ({ children, className }) => (
  <h3 className={classnames('text-2xl tracking-[0.48px] font-p22', className)}>{children}</h3>
)
